import { useEffect, useRef, useState } from "react";
import Calender from "../../assets/images/icons/Breadcrumbs/calendar_month.svg";
import Clock from "../../assets/images/icons/Breadcrumbs/clock.svg";
import Switch from "@mui/material/Switch";
import FloatTitleCard from "../../components/cards/floatTitleCard";
import sideColor from "../../assets/images/icons/Breadcrumbs/sideColor.svg";
import help from "../../assets/images/icons/Breadcrumbs/help.svg";
import { useMediaQuery } from "@mui/material";
import DeleteVisitModal from "../../components/modals/auth/DeleteVisitModal";
import RepeatVisitModal from "../../components/modals/auth/RepeatVisitModal";
import ApplyVisitModal from "../../components/modals/auth/ApplyVisitModal";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import serverConfig from "../../utilities/serverConfig.json";
import apiConfig from "../../utilities/apiConfig.json";
import { toast } from "react-toastify";
import "moment/locale/fa";
import DefaultDoctor from "../../assets/images/icons/DoctorProfileDefualt.svg";
import DefualtUser from "../../assets/images/icons/UserProfileDefualt.svg";
import constData from "../../utilities/const.json";
import TurnDetailSkt from "../../components/Skeletons/TurnDetailSkt";
import CustomeModal from "../../components/modals/CustomeModal";

const label = { inputProps: { "aria-label": "Switch demo" } };

const Turns = () => {

  const isLargeScreen = useMediaQuery("(min-width: 992px)");
  const { token, roles } = useSelector((state) => state.user);
  const tokenLocal = localStorage.getItem("token");
  const headers = { Authorization: "Bearer " + (token ? token : tokenLocal) };
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const TurnID = queryParams.get("id") ? queryParams.get("id") : null;
  const [loading, setLoading] = useState(true);
  const [paymentLoading, setPaymentLoading] = useState(false)
  const [data, setData] = useState();
  const [comments, setComments] = useState();
  const [paymentToken, setPaymentToken] = useState(null);
  const formRef = useRef(null);
  const [status, setStatus] = useState("temp");
  const navigate = useNavigate();
  const [remainingTime, setRemainingTime] = useState("");
  const [insurance, setInsurance] = useState(null)
  const [nationalId, setNationalID] = useState('')
  const [cancelEventLoading, setCancelEventLoading] = useState(false)
  const [canPay, setCanPay] = useState(true)
  const [total_visit_amount, set_total_visit_amount] = useState(null)
  const [isInsuranceConfirmed, setIsInsuranceConfirmed] = useState(false)
  const [insuranceLoading, setInsuranceLoading] = useState(false)
  const shouldShowLimitTimeTurn = !(roles.length === 1 && roles[0] === "user");
  const isPaymentUnpaid = data?.payment_status;
  const [params] = useSearchParams()

  const event_id = data?.event_id

  const getTurnDetail = () => {
    axios
      .get(
        serverConfig.server.url + apiConfig.api.getAPIs.eventDetail + TurnID,
        {
          headers,
        }
      )
      .then((response) => {
        setLoading(false);

        if (response.data.status === "success") {
          sessionStorage.removeItem('redirect-after-login')
          setData(response?.data?.data);
        } else {

          if (response.data.code == 401) {
            const eventID = params.get('id')
            sessionStorage.setItem('redirect-after-login', eventID)
            return navigate('/login')
          }

          if (response.data.code == 404) {
            navigate("/404");
          } else if (typeof response.data.errors === typeof "String") {
            toast.error(response.data.errors);
          } else {
            response.data.errors.forEach((element) => {
              toast.error(element);
            });
          }

          if (response.data.code == 403) return navigate('/')

        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error("Error making API call:", error);
      });
  };

  const getTurnComments = () => {
    axios
      .get(
        serverConfig.server.url +
        apiConfig.api.getAPIs.eventDetail +
        TurnID +
        "/comments",
        {
          headers,
        }
      )
      .then((response) => {
        setLoading(false);
        if (response.data.status === "success") {
          setComments(response.data.data.comments_list);
        } else {
          if (response.data.code == 404) {
            navigate("/404");
          } else if (typeof response.data.errors === typeof "String") {
            toast.error(response.data.errors);
          } else {
            response.data.errors.forEach((element) => {
              toast.error(element);
            });
          }
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error("Error making API call:", error);
      });
  };

  const ConfirmVisit = (newStatus) => {
    axios
      .post(
        serverConfig.server.url + apiConfig.api.updateAPIs.updateEvent + TurnID,
        {
          status: newStatus,
        },
        { headers }
      )
      .then((response) => {
        if (response?.data?.status === "success") {
          toast.success(response?.data?.message);
        } else {
          if (response?.data?.code == 404) {
            navigate("/404");
          } else if (typeof response?.data?.errors === typeof "String") {
            toast.error(response?.data?.errors);
          } else {
            response?.data?.errors?.forEach((element) => {
              toast.error(element);
            });
          }
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error("Error making API call:", error);
      });
  };

  const handleSwitchChange = () => {
    const newStatus = status === "temp" ? "certain" : "temp";
    setStatus(newStatus);
    ConfirmVisit(newStatus);
  };

  const applyInsurance = async () => {

    if (isInsuranceConfirmed) return;
    if (nationalId?.trim().length !== 10) return toast.error('کد ملی باید 10 رقم باشد.');

    const route = serverConfig.server.url + apiConfig.api.userControllers.applyInsurance
    let requestMessage;

    try {

      setInsuranceLoading(true)

      const { data: applyInsuranceStatus } = await axios.post(route,
        {
          national_id: nationalId,
          event_id: data.event_id,
          insurance_id: insurance.id
        }, { headers: headers }
      )

      if (applyInsuranceStatus.status === 'success') {
        set_total_visit_amount(applyInsuranceStatus?.data?.final_amount)
        setIsInsuranceConfirmed(true)
        setCanPay(true)
        setData(prev => ({ ...prev, insurance_name: insurance?.name }))
        toast.success(applyInsuranceStatus?.message)
        return
      }

      setCanPay(false)

      const errorMessage = typeof applyInsuranceStatus.errors === 'object' ? applyInsuranceStatus.errors.join(',') : applyInsuranceStatus.errors

      toast.error(errorMessage)
      requestMessage = errorMessage

    } catch (error) { toast.error(requestMessage) }
    finally { setInsuranceLoading(false) }

  }

  const CreateDataToPayment = async () => {

    setPaymentLoading(true);

    try {

      const response = await axios.post(
        serverConfig.server.url + apiConfig.api.addAPIs.sendDataToPayment,
        {
          event_id: TurnID,
          gateway: "sep",
        },
        { headers }
      );

      if (response.data.status === "success") {
        if (response.data.data?.token) return setPaymentToken(response.data.data.token);
        toast.success('پرداخت با موفقیت انجام شد');
        setData(prev => ({ ...prev, payment_status: 'payed' }))
      } else {
        if (typeof response.data.error === "string") {
          toast.error(response.data.error);
        } else if (Array.isArray(response.data.error)) {
          response.data.error.forEach((element) => {
            toast.error(element);
          });
        } else {
          toast.error("An unexpected error occurred");
        }
      }
    } catch (error) {
      toast.error("Failed to process the payment. Please try again.");
    } finally {
      setPaymentLoading(false);
    }
  };

  const deleteInsurance = async () => {

    setInsuranceLoading(true)

    try {

      const route = serverConfig.server.url + apiConfig.api.userControllers.deleteInsurance
      const response = await axios.post(route, { event_id: data?.event_id }, { headers })

      if (response?.data?.status === 'success') {
        toast.success(response?.data?.message)
        setIsInsuranceConfirmed(false)
        setData(prev => ({ ...prev, insurance_name: null }))
        set_total_visit_amount(response?.data?.deposit_amount)
        return
      }

      toast.error(response?.data?.errors)

    } catch { toast.error('خطایی رخ داد') }
    finally { setInsuranceLoading(false) }

  }

  const cancelEvent = async () => {

    setCancelEventLoading(true)

    try {

      const eventRoute = serverConfig.server.url + apiConfig.api.dashboardControllers.showEvents + apiConfig.api.cancelEvents.cancelEvent + '/' + event_id

      const { data } = await axios.get(eventRoute, { headers })

      if (data?.status === 'success') return toast.success(data?.data)

      if (typeof data?.errors === typeof "String") {
        toast.error(data?.errors);
      } else {
        data?.error.forEach((element) => {
          toast.error(element);
        });
      }


    } catch (error) { toast.error(error); console.log(error) }
    finally { setCancelEventLoading(false) }

  }

  const handleClick = () => {
    !insuranceLoading && !paymentLoading && canPay && CreateDataToPayment()
  }

  useEffect(() => {
    if (TurnID) {
      getTurnDetail();
      getTurnComments();
    }
  }, [TurnID]);

  useEffect(() => {
    if (data?.event_id) {

      const insuranceID = data?.insurance_id
      const insuranceList = data?.insurances_list

      if (insuranceID) {
        const insuranceData = insuranceList.find(data => data.id == insuranceID)
        setInsurance(insuranceData)
        setIsInsuranceConfirmed(true)
      }

      if (data?.patient_national_id) setNationalID(data.patient_national_id)

    }
  }, [data?.event_id, data?.insurances_list]);

  useEffect(() => {
    if (paymentToken && formRef.current) {
      formRef.current.submit();
    }
  }, [paymentToken]);

  return (
    <>
      {
        loading
          ?
          <TurnDetailSkt />
          :
          <div>
            <div className="pt-2 position-relative">

              <div className="timeVisitTurns background-bootstrap-gray-900 d-grid col-lg-1 col-3 text-center position-absolute tw-w-min">
                <span className="fw-normal fs-14 color-bootstrap-gray-100 text-nowrap fit-content">
                  زمان نوبت
                </span>
              </div>

              <div className="dateCardTime background-bootstrap-gray-100 border-radius-8  border-gray-300 d-grid col-lg-4 col-12 align-items-center mt-3 ">
                <div className="d-flex justify-content-start  align-items-center gap-5">
                  <div className="d-flex gap-2 align-items-center">
                    <img src={Calender} />
                    <span>
                      {data?.persian_date + ' ' + data?.date.slice(0, 4)}
                    </span>
                  </div>
                  <div className="d-flex gap-2 align-items-center">
                    <img src={Clock} />
                    <span className="fw-normal fs-16 color-bootstrap-gray-800 tw-text-nowrap">
                      {data?.time}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            {isPaymentUnpaid == "unpaid" && (
              <div className="border border-bootstrap-gray-300 mt-4 border-radius-16">

                <div className="d-flex justify-content-between limitTimeTurnUp background-bootstrap-gray-900 p-3">

                  <span className="fw-normal fs-16 color-bootstrap-gray-100">زمان باقی مانده تا انقضا نوبت</span>

                  <span className="fw-normal fs-16 color-bootstrap-gray-100">{data.time_to_expiring ?? "رد شده"}</span>

                </div>

                <div className="limitTimeTurnDown d-flex flex-column gap-3 mt-1">

                  <div>

                    <span className="fw-medium fs-14 color-bootstrap-gray-800">
                      این نوبت ثبت نهایی نشده و تا{" "}
                      <span className=" color-bootstrap-gray-800 fs-14 fw-bold">{data.time_to_expiring ?? "_"}</span>{" "}
                      دیگر برای شما رزرو شده است. جهت تایید نهایی نوبت نسبت به پرداخت
                      اقدام کنید.
                    </span>

                  </div>


                  {shouldShowLimitTimeTurn && (
                    <div className="d-flex w-100 justify-content-between align-items-center background-bootstrap-gray-200 p-2 border-radius-4 d-grid col-12 col-lg-7 position-relative">
                      <span className=" fw-normal fs-14 color-bootstrap-gray-700">
                        قطعی کردن نوبت
                      </span>
                      <div className="switchTurn">
                        <Switch
                          {...label}
                          checked={status === "certain"}
                          onChange={handleSwitchChange}
                        />
                      </div>
                    </div>
                  )}

                  {
                    (data?.insurances_list && data.insurances_list?.length)
                      ?
                      <div className="p-2 rounded-1 flex-column gap-2 d-flex justify-content-between background-bootstrap-gray-200">

                        <span>نوع بیمه</span>

                        {
                          data.insurances_list.map(({ id, name }) =>
                            <div
                              key={name}
                              onClick={() => {
                                if (isInsuranceConfirmed) return
                                setInsurance({ id, name })
                                setCanPay(false)
                              }}
                              className={`d-flex flex-column gap-1 p-2 bg-white cursor-pointer ${insurance?.name !== name ? 'rounded-1' : 'tw-border tw-border-[#360D9] tw-rounded-lg'}`}
                            >

                              <div className="d-flex align-items-center gap-2">
                                <img src={insurance?.name === name ? "./Ellipse 94.png" : './Ellipse-gray.png'} alt="Ellipse 94.png" />
                                <div>{name}</div>
                              </div>

                              {
                                insurance?.name === name ?

                                  <div className="d-flex align-items-center gap-2 w-100">

                                    <input
                                      value={nationalId}
                                      onChange={e => { if (!isInsuranceConfirmed) setNationalID(e.target.value) }}
                                      className={`flex-fill tw-py-2 tw-px-3 tw-border ${isInsuranceConfirmed ? 'tw-bg-[#F6FFED] tw-text-[#135200]' : 'tw-bg-white tw-text-[#495057]'} tw-rounded-lg tw-outline-none tw-h-12`}
                                      style={{ padding: '8px 12px', border: isInsuranceConfirmed ? '1px solid #52C41A' : '1px solid #CED4DA' }}
                                      type="text"
                                      placeholder="کد ملی مراجعه کننده"
                                    />

                                    {
                                      insuranceLoading
                                        ?
                                        <div className="spinner-border text-primary" role="status"><span className="sr-only"></span></div>
                                        :
                                        <div
                                          onClick={isInsuranceConfirmed ? deleteInsurance : applyInsurance}
                                          className={`py-1 d-flex align-items-center tw-rounded-md tw-bg-[#0360D9] tw-h-12 tw-cursor-pointer px-2 fs-16 fw-regularer ${isInsuranceConfirmed ? 'border border-danger text-danger bg-white' : 'text-white'}`}>
                                          {isInsuranceConfirmed ? 'حذف' : 'تایید'}
                                        </div>
                                    }

                                  </div>

                                  : null
                              }

                            </div>
                          )
                        }

                        <div onClick={() => {
                          if (isInsuranceConfirmed) return
                          setInsurance(null)
                          setCanPay(true)
                        }} className="p-2 rounded-1 gap-2 d-flex justify-content-between background-bootstrap-gray-200 bg-white cursor-pointer">
                          <div className="d-flex align-items-center gap-2">
                            <img src={!insurance ? "./Ellipse 94.png" : './Ellipse-gray.png'} alt="Ellipse 94.png" />
                            <p className="m-0 tw-bg-[#6C757Ds] fs-16 fw-light">ندارم</p>
                          </div>
                        </div>

                      </div>
                      : null
                  }

                  {
                    (data?.payment_status && data?.payment_status == 'unpaid')
                      ?
                      <div
                        className={`d-flex tw-justify-end tw-w-min gap-3 tw-min-w-fit col-lg-4 col-10 buttonPayTurn border-radius-4 bg-iso-blue-300 ms-auto ${!canPay && 'opacity-50 cursor-none'}`}
                        onClick={handleClick}
                      >
                        <span className=" fw-medium fs-18 color-bootstrap-gray-100">
                          پرداخت و ثبت نهایی
                        </span>
                        <span className=" fw-medium fs-18 color-bootstrap-gray-100">
                          {(
                            total_visit_amount ?? (data?.pazirex_patient_service_amount + data?.deposit_amount)
                          )?.toLocaleString("fa-IR")}{" "}
                          <span className="fs-10">تومان</span>
                        </span>
                      </div>
                      : null
                  }

                </div>

              </div>
            )}

            <div className="pt-2 ">
              <div className="row">
                <div className="col-lg-6 col-12">
                  <div className="col-12 color-bootstrap-gray-700">
                    <FloatTitleCard title={"اطلاعات پزشک"} error={false}>
                      <div className="d-flex row px-12px">
                        <div className="d-flex col col-12 px-0 align-items-center border-bottom pb-2">
                          <img
                            width="55"
                            height="55"
                            className="rounded-pill me-2"
                            src={data?.doctor_file || DefaultDoctor}
                          />
                          <div
                            className="d-flex row"
                            style={{ height: isLargeScreen ? "55px" : "48px" }}
                          >
                            <span className=" fw-medium fs-14 color-bootstrap-gray-800">
                              {data?.doctor_first_name} {data?.doctor_last_name}
                            </span>
                            <span className="fw-normal fs-12 mt-1 color-bootstrap-gray-600 mt-1">
                              {data?.doctor_title}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="d-flex flex-column mt-1 fs-14 color-bootstrap-gray-700">
                        <span className="ps-2 my-1  fw-medium fs-14 color-bootstrap-gray-800">
                          مرکز درمانی :
                          <span className="ms-1 fw-normal fs-12 mt-1 color-bootstrap-gray-600">
                            {data?.place_title}
                          </span>
                        </span>
                        <span className="ps-2 my-1  fw-medium fs-14 color-bootstrap-gray-800">
                          دپارتمان :
                          <span className="ms-1 fw-normal fs-12 mt-1 color-bootstrap-gray-600">
                            {data?.department_title}
                          </span>
                        </span>
                        <span className="ps-2 my-1  fw-medium fs-14 color-bootstrap-gray-800">
                          آدرس :
                          <span className="ms-1 fw-normal fs-12 mt-1 color-bootstrap-gray-600">
                            {data?.place_address}
                          </span>
                        </span>
                      </div>
                    </FloatTitleCard>
                  </div>
                  <div className=" col-12 color-bootstrap-gray-700">
                    <FloatTitleCard title={"اطلاعات بیمار"} error={false}>
                      <div className="d-flex row px-12px">
                        <div className="d-flex col col-12 px-0 align-items-center border-bottom pb-2">
                          <img
                            width="55"
                            height="55"
                            className="rounded-pill me-2"
                            src={data?.patient_file || DefualtUser}
                          />
                          <div
                            className="d-flex row"
                            style={{ height: isLargeScreen ? "55px" : "48px" }}
                          >
                            <span className="fw-medium fs-14 color-bootstrap-gray-800">
                              {data?.patient_first_name} {data?.patient_last_name}
                            </span>
                            <span className="fw-normal fs-12 mt-1 color-bootstrap-gray-600 mt-1">
                              {data?.patient_national_id && data.patient_national_id + ' | '}{" "}
                              {constData.roleName[data?.creator_role.toString()]}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="d-flex flex-column mt-1 fs-14 color-bootstrap-gray-700">
                        <div className="tw-flex sm:tw-flex-row tw-flex-row tw-items-center tw-justify-between">

                          <span className="ps-2 my-1 fw-medium fs-14 color-bootstrap-gray-800">
                            شناسه نوبت :
                            <span className=" ms-1 fw-normal fs-12 mt-1 color-bootstrap-gray-600">
                              {data?.event_id}
                            </span>
                          </span>

                          {
                            data?.patient_mobile
                              ?
                              <span className="ps-2 my-1 fw-medium fs-14 color-bootstrap-gray-800">
                                شماره موبایل :
                                <span className=" ms-1 fw-normal fs-12 mt-1 color-bootstrap-gray-600">
                                  {data?.patient_mobile}
                                </span>
                              </span>
                              : null
                          }


                        </div>

                        {
                          data?.insurance_name
                            ?
                            <span className="ps-2 my-1 fw-medium fs-14 color-bootstrap-gray-800">
                              بیمه :
                              <span className=" ms-1 fw-normal fs-12 mt-1 color-bootstrap-gray-600">
                                {data?.insurance_name}
                              </span>
                            </span>
                            : null
                        }

                        <div className="d-flex gap-2 ps-2 my-1">
                          {
                            data?.payment_status === "unpaid"
                              ?
                              <span className="waitToPayTurn background-bootstrap-light-warning border-radius-24 fw-normal fs-12">
                                درانتظار پرداخت
                              </span>
                              :
                              <span className="paidTpPayTurn border-radius-24 fw-normal fs-12 color-bootstrap-regular-success">
                                پرداخت شده
                              </span>
                          }
                          {
                            remainingTime ?

                              <span className="visitTimeTurn border-radius-24 background-bootstrap-gray-200 fw-normal fs-12 color-bootstrap-gray-700">
                                {remainingTime}
                              </span>
                              : null
                          }
                        </div>

                      </div>
                    </FloatTitleCard>
                  </div>
                  <div className=" col-12 color-bootstrap-gray-700">
                    <FloatTitleCard title={"صورت حساب"} error={false}>

                      <div className="d-flex flex-column border-bottom pb-2 gap-2">

                        <div className="d-flex justify-content-between">
                          <span className="fw-medium fs-14 color-bootstrap-gray-800">
                            {`هزینه خدمات ${data?.doctor_title ?? ''} ${data?.doctor_last_name ?? ''}`}
                          </span>
                          <span className="fw-normal fs-16 color-bootstrap-gray-600">
                            {data?.total_visit_amount?.toLocaleString("fa-IR") ?? 0}{" "}
                            <span className="fs-10">تومان</span>
                          </span>
                        </div>

                        <div className="d-flex justify-content-between">
                          <div className="d-flex gap-1">
                            <span className="fw-medium tw-text-nowrap fs-14 color-bootstrap-gray-800">
                              مبلغ بیعانه
                            </span>
                            <img src={help} />
                          </div>
                          <span className="fw-normal fs-16 color-bootstrap-gray-600">
                            {data?.deposit_amount?.toLocaleString("fa-IR") ?? 0}{" "}
                            <span className="fs-10">تومان</span>
                          </span>
                        </div>

                        {
                          data?.pazirex_patient_service_amount
                            ?
                            <div className="d-flex justify-content-between">
                              <span className="fw-medium fs-14 color-bootstrap-gray-800">
                                هزینه نوبت دهی آنلاین
                              </span>
                              <span className="fw-normal fs-16 color-bootstrap-gray-600">
                                {data?.pazirex_patient_service_amount?.toLocaleString("fa-IR") ?? 0}{" "}
                                <span className="fs-10">تومان</span>
                              </span>
                            </div>
                            : null
                        }

                        <div className="d-flex justify-content-between">
                          <span className="fw-medium tw-text-nowrap fs-14 color-bootstrap-gray-800">
                            قابل پرداخت در مطب
                          </span>
                          <span className="fw-normal fs-16 color-bootstrap-gray-600">
                            {(data?.total_visit_amount - data?.deposit_amount)?.toLocaleString("fa-IR") ?? 0}{" "}
                            <span className="fs-10">تومان</span>
                          </span>
                        </div>

                      </div>

                      <div className="factorTurn mt-2 border-radius-8 border-gray-200">
                        <div className="d-flex justify-content-between align-items-center">
                          <div className="d-flex align-items-center gap-2">
                            <img src={sideColor} />
                            <span className="fw-medium fs-12 color-bootstrap-gray-700">
                              مبلغ نهایی دریافتی
                            </span>
                          </div>
                          <div className="factorPriceField mx-2 border-radius-4">
                            <span className="priceFinalFactor fs-12 fw-normal">
                              {(data?.total_visit_amount + data?.pazirex_patient_service_amount)?.toLocaleString("fa-IR")}{" "}
                              <span className="fs-10">تومان</span>
                            </span>
                          </div>
                        </div>
                        {data?.description && (
                          <div className="infoFactorPrice mx-2 mt-2 p-2 border-radius-8 background-bootstrap-gray-100">
                            <p className="infoFactorTurn fw-normal fs-10 color-bootstrap-gray-700">
                              {data.description}
                            </p>
                          </div>
                        )}
                      </div>

                    </FloatTitleCard>
                  </div>
                </div>

                {shouldShowLimitTimeTurn && (
                  <div className="col-lg-6 col-12">
                    <div className="col-12 color-bootstrap-gray-700">
                      <FloatTitleCard title={"یادداشت‌ها"} error={false}>
                        {comments?.map((comment, index) => (
                          <div
                            key={index}
                            className={`d-flex row border-radius-8 border-gray-400 p-2 background-bootstrap-gray-100 px-12px ${index > 0 ? "mt-4" : ""
                              }`}
                          >
                            <div className="d-flex col col-12 px-0 align-items-center border-bottom pb-2">
                              <img
                                width="55"
                                height="55"
                                className="rounded-pill me-2"
                                src={comment?.file || DefualtUser} // Assuming comment has an image property, fallback to DefualtUser if not available
                                alt="Doctor"
                              />
                              <div
                                className={`${isLargeScreen ? 'tw-h-[55px]' : 'tw-h-12'}`}>
                                <span className="fw-medium fs-14 color-bootstrap-gray-800">
                                  {comment?.creator_first_name}{" "}
                                  {comment?.creator_last_name}
                                </span>
                                <span className="fw-normal fs-12 mt-1 color-bootstrap-gray-600 mt-1">
                                  {comment?.last_degree}
                                </span>
                              </div>
                            </div>
                            <div className="fw-normal fs-14 color-bootstrap-gray-800  mt-3">
                              <span>{comment?.content}</span>
                            </div>
                            <div className="d-flex justify-content-between mt-3">
                              <span className="fw-normal fs-12 color-bootstrap-gray-600">
                                {comment?.date}
                              </span>
                              <span className="fw-normal fs-12 color-bootstrap-gray-600">
                                {comment?.time}
                              </span>
                            </div>
                          </div>
                        ))}

                        <div className="d-flex justify-content-end align-items-center mt-2">
                          <button
                            type="submit"
                            className="add-new-comment border-radius-8 border-0 bg-iso-blue-300 fw-medium fs-16 color-bootstrap-gray-100"
                            data-bs-toggle="modal"
                            data-bs-target="#applyVisitModal"
                          >
                            نوشتن نظر جدید
                          </button>
                        </div>
                      </FloatTitleCard>
                    </div>
                  </div>
                )}
              </div>
              {shouldShowLimitTimeTurn && (
                <div className="d-grid col-lg-6 col-12 mt-4  justify-content-lg-end justify-content-center d-flex gap-3">
                  <button
                    className="color-bootstrap-regular-danger fw-medium fs-16 bg-transparent border-0"
                    data-bs-toggle="modal"
                    data-bs-target="#customeModal"
                  >
                    لغو نوبت
                  </button>
                  <button
                    className="color-bootstrap-regular-danger fw-medium fs-16 bg-transparent border-0"
                    data-bs-toggle="modal"
                    data-bs-target="#deleteVisitModal"
                  >
                    حذف نوبت
                  </button>
                  <button
                    className="buttonRepeatVisit border-radius-8 border-iso-blue-300 bg-white"
                    onClick={() => {
                      navigate(
                        `/booking?pl=${data?.place_id}&dep=${data?.department_id}&dr=${data?.doctor_id}`
                      );
                    }}
                  >
                    نوبت مجدد
                  </button>
                  <button
                    className="buttonApplyVisit border-radius-8 border-0 fw-medium fs-16 bg-iso-blue-300 color-bootstrap-gray-100"
                    data-bs-toggle="modal"
                    data-bs-target="#repeatVisitModal"
                  >
                    ویزیت شد
                  </button>
                </div>
              )}
            </div>
            <CustomeModal bodyText="آیا از لغو نوبت اطمینان دارید؟" isLoading={cancelEventLoading} onSubmitProp={cancelEvent} />
            <ApplyVisitModal id={TurnID} doctorId={data?.doctor_id} />
            <DeleteVisitModal id={TurnID} />
            <RepeatVisitModal
              id={TurnID}
              currentTotalVisitAmount={data?.total_visit_amount}
              updateTurns={() => window.location.reload()}
            />
            {
              paymentToken && (
                <form
                  action="https://sep.shaparak.ir/OnlinePG/OnlinePG"
                  method="post"
                  ref={formRef}
                  onLoad={() => formRef.current && formRef.current.submit()}
                >
                  <input type="hidden" name="Token" value={paymentToken} />
                  <input type="hidden" name="GetMethod" value="true" />
                </form>
              )
            }
          </div >
      }
    </>
  );
};

export default Turns;
